import React, { useState, useEffect } from "react";
import axios from "axios";
import { api_url } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddToCartModal = ({ show, onClose, onSubmit,onAddAgain, userId,prescription_id }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedProducts, setExpandedProducts] = useState([]);
  const [cartSelections, setCartSelections] = useState({}); 
  const [quantityErrors, setQuantityErrors] = useState({}); 
  
  const [cartResponse, setCartResponse] = useState({ show: false, successes: [], errors: [] });

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 400);
    return () => clearTimeout(handler);
  }, [searchTerm]);


  useEffect(() => {
    if (!debouncedSearchTerm) {
      setProducts([]);
      return;
    }
    setLoading(true);
    axios
      .get(`${api_url}/products-search?query=${debouncedSearchTerm}`, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
      })
      .then((res) => {
        setProducts(res.data?.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [debouncedSearchTerm]);


  const handleExpandProduct = (product) => {
    setExpandedProducts((prev) =>
      prev.includes(product.product_id)
        ? prev.filter((id) => id !== product.product_id)
        : [...prev, product.product_id]
    );

    setCartSelections((prev) => {
      if (!prev[product.product_id]) {
        return {
          ...prev,
          [product.product_id]: {
            product,
            variants: {},
          },
        };
      }
      return prev;
    });
  };


  const handleVariantChange = (productId, variantId, field, value, variantObj) => {
  
    if (field === 'quantity' && variantObj) {
      if (value > variantObj.quantity) {
        setQuantityErrors(prev => ({
          ...prev,
          [productId]: {
            ...(prev[productId] || {}),
            [variantId]: 'Quantity limit exceeded',
          },
        }));
        return; 
      } else {
      
        setQuantityErrors(prev => {
          if (prev[productId]?.[variantId]) {
            return {
              ...prev,
              [productId]: {
                ...(prev[productId] || {}),
                [variantId]: '',
              },
            };
          }
          return prev;
        });
      }
    }
    setCartSelections((prev) => ({
      ...prev,
      [productId]: {
        ...prev[productId],
        variants: {
          ...prev[productId]?.variants,
          [variantId]: {
            ...prev[productId]?.variants?.[variantId],
            [field]: value,
          },
        },
      },
    }));
  };



  const handleRemoveProduct = (productId) => {
    setCartSelections((prev) => {
      const updated = { ...prev };
      delete updated[productId];
      return updated;
    });
    setExpandedProducts((prev) => prev.filter((id) => id !== productId));
  };

  const handleRemoveVariant = (productId, variantId) => {
    setCartSelections((prev) => {
      const updated = { ...prev };
      if (updated[productId]) {
        updated[productId] = {
          ...updated[productId],
          variants: { ...updated[productId].variants },
        };
        delete updated[productId].variants[variantId];
      }
      return updated;
    });
  };


  const getSelectedItems = () => {
    let selected = [];
    Object.entries(cartSelections).forEach(([productId, { product, variants }]) => {
      Object.entries(variants).forEach(([variantId, v]) => {
        if (v.checked && v.quantity > 0) {
          selected.push({
            product_id: productId,
            variant_id: variantId,
            quantity: v.quantity,
          });
        }
      });
    });
    return selected;
  };


 

  const handleAddToCart = () => {
    const selected = getSelectedItems();
    if (selected.length === 0) return;
    setLoading(true);
    axios.post(
      `${api_url}/admin/prescription-cart/${userId}`,
      { products: selected,prescription_id:prescription_id},
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        setLoading(false);
        setCartResponse({
          show: true,
          successes: response.data.data.successes || [],
          errors: response.data.data.errors || [],
        });
       
      })
      .catch((error) => {
        setLoading(false);
        setCartResponse({
          show: true,
          successes: [],
          errors: [error?.response?.data?.message || error?.message || 'Failed to add to cart'],
        });
      });
  };

    const handleRemoveFromCart = async (productId, variant_id) => {

    try {
      const response = await fetch(`${api_url}/admin/cart-delete/${userId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
        body: JSON.stringify({ product_id: productId, variant_id: variant_id, prescription_id: prescription_id, }),
      });

  
      if (response.ok) {
        toast.success("Product Deleted Succussfully")
        setCartResponse((prev) => ({
          ...prev,
          successes: prev.successes.filter(
            (item) => !(item.product_id === productId && item.variant_id === variant_id)
          ),
        }));
      }
    } catch (err) {
      console.error("Failed to remove product from cart:", err);
    }
  };



 
  const isCartReady = Object.values(cartSelections).some(({ variants }) =>
    Object.values(variants || {}).some((v) => v.checked && v.quantity > 0)
  );

  if (!show) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white ml-6 rounded-lg shadow-lg p-8 w-full max-w-6xl relative min-h-100vh overflow-y-auto scrollbar-thin">
        <button
                className="absolute top-2 right-2 text-2xl text-gray-400 hover:text-gray-700"
                onClick={() => {
                  setCartResponse({ show: false, successes: [], errors: [] });
                  setCartSelections({});
                  setSearchTerm("");
                  setExpandedProducts([]);
                  onAddAgain && onAddAgain();
                }}
              >
                &times;
              </button>
          {cartResponse.show ? (
            <div className="p-6 w-full max-w-lg relative">
              
            {cartResponse.successes.length > 0 && (
              <div className="mb-6">
                <h2 className="text-lg font-bold text-green-600 mb-3">
                  Successfully Added to Cart
                </h2>
                <div className="flex flex-wrap gap-4">
                  {cartResponse.successes.map((item, idx) => (
                    <div
                      key={idx}
                      className="relative flex flex-col items-center text-center border border-green-400 bg-green-50 rounded-xl p-3 w-32 shadow-sm"
                    >
                      {/* Delete icon inside card */}
                      <div
                        className="delete-icon cursor-pointer absolute top-2 right-2 transition duration-200 ease-in-out"
                        onClick={() =>
                          handleRemoveFromCart(item.product_id, item.variant_id)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="h-5 w-5 text-gray-500 hover:text-red-600 transition duration-200"
                        >
                          <polyline points="3 6 5 6 21 6"></polyline>
                          <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2"></path>
                          <path d="M10 11v6"></path>
                          <path d="M14 11v6"></path>
                          <path d="M4 6h16"></path>
                          <path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14"></path>
                        </svg>
                      </div>

                      {item.product_image ? (
                        <img
                          src={item.product_image}
                          alt={item.product_name}
                          className="w-16 h-16 object-contain rounded"
                        />
                      ) : (
                        <div className="w-16 h-16 rounded bg-gray-200 flex items-center justify-center text-gray-500">
                          No Img
                        </div>
                      )}

                      <p className="font-semibold text-sm mt-2">{item.product_name}</p>
                      <p className="text-xs text-gray-600">
                        Req: {item.requested_quantity}, Add: {item.added_quantity}
                      </p>
                      <p className="text-xs text-gray-700">
                        Price: ₹{item.price}
                      </p>
                      <p className="text-xs font-medium text-green-700">
                        Total: ₹{item.total_price}
                      </p>
                      <p className="text-xs text-green-700 font-medium">{item.status}</p>
                    </div>
                  ))}

                </div>
              </div>
            )}

            {cartResponse.errors.length > 0 && (
              <div>
                <h2 className="text-lg font-bold text-red-600 mb-3">Failed to Add in Cart</h2>
                <div className="flex flex-wrap gap-4">
                  {cartResponse.errors.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex flex-col items-center text-center border border-red-400 bg-red-50 rounded-xl p-3 w-32 shadow-sm"
                    >
                      {item.product_image ? (
                        <img
                          src={item.product_image}
                          alt={item.product_name}
                          className="w-16 h-16 object-contain rounded"
                        />
                      ) : (
                        <div className="w-16 h-16 rounded bg-gray-200 flex items-center justify-center text-gray-500">
                          No Img
                        </div>
                      )}
                      <p className="font-semibold text-sm mt-2">{item.product_name}</p>
                      <p className="text-xs text-gray-600">
                        Req: {item.requested_quantity}, Add: {item.added_quantity}
                      </p>
                      <p className="text-xs text-gray-700">
                        Price: ₹{item.price}
                      </p>
                      <p className="text-xs font-medium text-green-700">
                        Total: ₹{item.total_price}
                      </p>
                      <p className="text-xs text-red-700 font-medium">
                        {item.reason || item.status}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}



            <div className="mt-6 flex justify-end gap-4">
              <button
                className="px-5 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium shadow-sm hover:bg-gray-100 hover:text-gray-900 transition"
                onClick={() => {
                  setCartResponse({ show: false, successes: [], errors: [] });
                  setCartSelections({});
                  setSearchTerm("");
                  setExpandedProducts([]);
                  onClose && onClose();
                }}
                disabled={cartResponse.successes.length === 0 }
              >
                Proceed
              </button>

              <button
                className="px-5 py-2 rounded-lg bg-blue-600 text-white font-medium shadow-sm hover:bg-blue-700 transition"
                onClick={() => {
                  setCartResponse({ show: false, successes: [], errors: [] });
                  setCartSelections({});
                  setSearchTerm("");
                  setExpandedProducts([]);
                  onAddAgain && onAddAgain();
                }}
              >
                Add More
              </button>
            </div>
            </div>
          ) : (
            <>
              <button
            className="absolute top-2 right-2 text-2xl text-gray-400 hover:text-gray-700"
            onClick={() => {
                  setCartResponse({ show: false, successes: [], errors: [] });
                  setCartSelections({})
                  setSearchTerm("")
                  setExpandedProducts([])
                  setProducts([])
                  onClose && onClose();
            }}
          >
            &times;
          </button>
        <h2 className="text-lg font-bold mb-4">Product Search</h2>

        <input
          type="text"
          placeholder="Search products by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-2 mb-4 border border-gray-300 rounded"
        />
        {loading ? (
          <div>Loading...</div>
        ) : products.length === 0 && searchTerm ? (
          <div className="text-gray-500">No products found.</div>
        ) : (
          <ul className="divide-y divide-gray-200 max-h-[180px] overflow-y-auto scrollbar-thin mb-2">
            {products.map((product) => (
              <li key={product.product_id} className="mb-2">
                <div
                  className="flex items-center gap-3 py-2 cursor-pointer hover:bg-gray-100 px-2 rounded justify-between"
                  onClick={() => handleExpandProduct(product)}
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={product.product_images?.image_url?.primary_image || "https://via.placeholder.com/40"}
                      alt={product.name}
                      className="w-10 h-10 object-cover rounded"
                    />
                    <span className="font-bold text-blue-600 font-poppins">{product.name}</span>
                  </div>
                  <span className="text-xs text-blue-600">
                    {expandedProducts.includes(product.product_id) ? "Hide" : "Select"}
                  </span>
                </div>

               
                {expandedProducts.includes(product.product_id) && (
                  <ul className="space-y-2 px-2 mt-2">
                    {(product.variant || []).map((variant) => (
                      <li
                        key={variant.variant_id}
                        className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-4 border rounded-lg shadow-sm bg-white"
                      >
                        <div className="flex flex-col sm:flex-row sm:items-center gap-4 flex-1 flex-wrap">
                          <span className="font-semibold font-poppins">Pack Size: {variant.pack_size}</span>
                          <span className="font-semibold">Product Size: {variant.product_size}</span>
                          {variant.discounted_price ? (
                            <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                              <span className="font-semibold">Price:</span>
                              <span className="line-through text-gray-500">₹{variant.price}</span>
                              <span className="text-green-600 font-semibold">₹{variant.discounted_price}</span>
                            </div>
                          ) : (
                            <div className="flex items-center gap-2">
                              <span className="font-semibold">Price:</span>
                              <span className="font-medium">₹{variant.price}</span>
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col items-start gap-2 sm:items-end">
                          <p className="text-sm font-medium">Quantity</p>
                          <div className="flex items-center gap-2">
                            <button
                              className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleVariantChange(
                                  product.product_id,
                                  variant.variant_id,
                                  "quantity",
                                  Math.max((cartSelections[product.product_id]?.variants?.[variant.variant_id]?.quantity || 0) - 1, 0),
                                  variant
                                );
                              }}
                            >
                              -
                            </button>
                            <span className="w-6 text-center">{cartSelections[product.product_id]?.variants?.[variant.variant_id]?.quantity || 0}</span>
                            <button
                              className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleVariantChange(
                                  product.product_id,
                                  variant.variant_id,
                                  "quantity",
                                  (cartSelections[product.product_id]?.variants?.[variant.variant_id]?.quantity || 0) + 1,
                                  variant
                                );
                              }}
                            >
                              +
                            </button>
                          </div>
                          {quantityErrors[product.product_id]?.[variant.variant_id] && (
                            <div className="text-xs text-red-600 mt-1">
                              {quantityErrors[product.product_id][variant.variant_id]}
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col items-start gap-2 sm:items-end">
                          <label className="text-sm font-medium mt-2 flex items-center gap-2">
                            Select
                            <input
                              type="checkbox"
                              checked={!!cartSelections[product.product_id]?.variants?.[variant.variant_id]?.checked}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleVariantChange(
                                  product.product_id,
                                  variant.variant_id,
                                  "checked",
                                  e.target.checked
                                );
                              }}
                            />
                          </label>
                        
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
       

        {(() => {
          const selectedProducts = Object.entries(cartSelections)
            .map(([productId, { product, variants }]) => ({
              product,
              variants: Object.entries(variants)
                .filter(([_, v]) => v.checked && v.quantity > 0)
                .map(([variantId, v]) => ({
                  ...v,
                  variant: product.variant.find(va => va.variant_id === variantId),
                  variantId,
                }))
            }))
            .filter(item => item.variants.length > 0);
          if (selectedProducts.length === 0) return null;
          return (
            (
              <div className="my-4 border border-gray-200 rounded-lg overflow-hidden">
                <div className="sticky top-0 bg-gray-800 text-white px-4 py-2 z-10 border-b border-gray-700">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-lg">Your Selected Items</h3>
                
                  </div>
                </div>
  
                <div className="my-4 max-h-[200px] overflow-y-auto scrollbar-thin pr-2">
                  <ul className="divide-y divide-gray-200">
                    {selectedProducts.map(({ product, variants }) => (
                      <li key={product.product_id} className="py-2">
                        <div className="flex items-center justify-between">
                          <span className="font-bold text-blue-600 ml-4">{product.name}</span>
                          <button className="text-xs text-red-500" onClick={() => handleRemoveProduct(product.product_id)}>Remove Product</button>
                        </div>
                        <ul className="ml-4 mt-1">
                          {variants.map(({ variant, quantity, variantId }) => (
                            <li key={variantId} className="flex flex-wrap items-center gap-4 text-sm border-b py-1 last:border-b-0">
                              <span className="font-semibold">Pack: {variant.pack_size}</span>
                              <span>Size: {variant.product_size}</span>
                              <span>
                                Price: {variant.discounted_price ? (
                                  <>
                                    <span className="line-through text-gray-500 mr-1">₹{variant.price}</span>
                                    <span className="text-green-600 font-semibold">₹{variant.discounted_price}</span>
                                  </>
                                ) : (
                                  <span>₹{variant.price}</span>
                                )}
                              </span>
                              <span>Qty: {quantity}</span>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )
          );
        })()}
        <div className="relative group w-full">
          <button
            className={`w-full mt-2 py-2 rounded font-semibold ${
              isCartReady
                ? "bg-green-600 hover:bg-green-700 text-white"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
            }`}
            onClick={handleAddToCart}
            disabled={!isCartReady}
          >
            Add to Cart
          </button>
          {!isCartReady && (
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
              Select a variant and quantity first
            </div>
          )}
        </div>
      </>
    )}
  </div>
</div>
 <ToastContainer />
</>
);
};

export default AddToCartModal;
